import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService } from '../../services/optimizer-service/optimizer.service';
import { ActivatedRoute } from '@angular/router';
import { Trip } from '../../DataStructures/Trip/Trip';
import { MatDialog, MatSlideToggleChange, ThemePalette } from '@angular/material';
import { Router, NavigationStart } from '@angular/router'
import * as moment from 'moment';
import { DateConstants } from '../../utilities/WeekSchedule/DateConstants';
import { CONSTANTS } from '../../utilities/Constants';
import { CompanyService } from '../../services/company-service/company.service';
import { MapControls } from '../../utilities/MapControls/MapConrols';
import { DirectionsService } from '../../utilities/DirectionsService/DirectionsService';
import { UnitConverter } from '../../utilities/unit-converter/UnitConverter';
import { Area } from '../../DataStructures/Area/Area';
import { environment } from '../../../environments/environment';
import { SocketService } from '../../socket.service';
import { QuickDialog } from '../../utilities/Dialog/QuickDialog';
import { DriverService } from '../../services/driver-service/driver.service';
import { AuthService } from '../../services/auth-service/auth.service';
import { PassengerImagesComponent } from '../../shared/passenger-images/passenger-images.component';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';
import { LocationValidator } from '../../utilities/location-validator/LocationValidator';
import { LocationData, LocationOptions } from '../location-picker/location-picker.component';
import { DeliveryFeeCalculation, stopLocationChanged } from '../../utilities/DeliveryFeeCalculation/DeliveryFeeCalculation';
import { VendorService } from '../../vendor-portal/vendor.service';
import { CustomerDiscountUtils } from '../../utilities/CustomerDiscount/CustomerDiscountUtils';

export type TripChangelogActorType = 'DISPATCHER' | 'DRIVER' | 'ADMIN' | 'SYSTEM' | 'UNKNOWN';

export interface TripChangelogChange {
  field: string;
  label: string;
  description: string;
  before: any;
  after: any;
}

export interface ChangelogDisplayLine {
  label?: string;
  value: string;
}

export interface TripChangelogEntry {
  index: number;
  time: string | null;
  modifiedBy: string | number;
  modifiedByDisplay: string;
  modifierRoles: string[];
  actorType: TripChangelogActorType;
  summary: string;
  changes: TripChangelogChange[];
}

export interface TripChangelogData {
  tripId: string;
  createdByEmail: string | null;
  lastModifiedByEmail: string | null;
  totalEntries: number;
  entries: TripChangelogEntry[];
}

export interface TripDetailsPassengerRow {
  uid: string;
  name: string;
  phone: string;
  email: string;
  addressText: string;
  locationInfo: { address: string; lat: any; lng: any } | null;
  userid: number | null;
  employeeid: string | null;
  detailsExpanded: boolean;
  showAutocomplete: boolean;
  filteredUsers: any[];
  isSearching: boolean;
  selectedUser: any;
  lastPersistFingerprint: string | null;
  persistInFlight: boolean;
}

declare var google: any;
declare var $: any;
@Component({
  selector: 'app-trip-details',
  templateUrl: './trip-details.component.html',
  styleUrls: ['./trip-details.component.css']
})
export class TripDetailsComponent implements OnInit {
  tripId;
  driverLocation = null;
  trip: Trip;
  lock = false;
  @ViewChild('map') mapReference: ElementRef;
  @ViewChild('driverSearch') driverSearch: ElementRef;
  company = null;
  color: ThemePalette = 'primary';
  mode: 'determinate';
  converter = new UnitConverter();
  value = 50;
  driverMarker;
  deliveryFeeCalculation: DeliveryFeeCalculation;
  cumulative = false;
  bufferValue = 75;
  settings: any;
  courierKey: string;
  drivers = [];
  filteredDrivers = [];
  directionsMarkers = [];
  formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  dragSourceIndex: number = -1;
  editingReportDate: boolean = false;
  editingReportDateValue: string = '';
  /**
   * Provider admins: map + Directions are off until the user opts in (saves Google usage).
   * Other roles keep the previous always-on behavior.
   */
  providerMapRouteOptIn = false;

  passengerRows: TripDetailsPassengerRow[] = [];
  private passengerSearchTimers: { [uid: string]: any } = {};
  private tripPassengerRowsTripKey: string | null = null;

  changeHistoryExpanded = false;
  changeHistoryLoading = false;
  changeHistoryLoaded = false;
  changeHistoryError: string | null = null;
  changeHistoryData: TripChangelogData | null = null;
  changeHistoryEntries: TripChangelogEntry[] = [];
  expandedChangelogEntryIndexes: { [index: number]: boolean } = {};

  constructor(
    private cdr: ChangeDetectorRef,
    private auth: AuthService,
    private driverService: DriverService,
    private router: Router,
    private socketService: SocketService,
    private dialog: MatDialog,
    private mapControls: MapControls,
    private main: MainService,
    private directions: DirectionsService,
    private route: ActivatedRoute,
    private vendor: VendorService,
    private companyService: CompanyService,
    private http: Http,
    private zone: NgZone) {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.socketService.disconnect();
      }
    });
  }

  ngOnInit() {
    sessionStorage.setItem('sidebarsate', 'open');
    const platform$ = this.driverService.getDrivers().then((r: any) =>
      this.driverService.mapDriverApiResponse(r || {}));
    const portal$ = this.driverService.getDrivers(null, { isPortal: true }).then((r: any) =>
      this.driverService.mapDriverApiResponse(r || {}));
    Promise.all([platform$, portal$]).then((pairs: any[]) => {
      const platformDrivers = pairs[0];
      const portalDrivers = pairs[1];
      const plat = Array.isArray(platformDrivers) ? platformDrivers : [];
      const port = Array.isArray(portalDrivers) ? portalDrivers : [];
      this.drivers = plat.concat(port);
      this.filteredDrivers = this.drivers;
    }).catch(() => {
      this.driverService.getDrivers().then((results: any) => {
        this.drivers = this.driverService.mapDriverApiResponse(results || {});
        this.filteredDrivers = this.drivers;
      });
    });
    this.route.params.subscribe(params => {
      const newId = params['id'];
      if (this.tripId != null && this.tripId !== newId && this.deferMapRouteForProviderAdmin) {
        this.providerMapRouteOptIn = false;
      }
      this.tripId = newId;
      this.resetChangeHistory();
      this.main.getTrip(this.tripId).then((result: any) => {
        if (result.data) {
          this.trip = Trip.createTripFromRawTripData(result.data);
          this.vendor.getVendorInfoById(this.trip.providerid).then((res) => {
            this.settings = res.data.settings;
            this.courierKey = res.data.code;
          }).catch(e => {
            console.log(e);
          })
          if (!this.trip.published) {
            new QuickDialog(this.dialog).InfoDialog("The trip has not been published, only when a trip is published it will be seen by drivers. Please ensure to publish the trip when you are done.", 'Trip Not Published', "OK");
          }
          this.registerSocketListeners();
          if (!this.deferMapRouteForProviderAdmin) {
            this.initializeMap();
          }
          this.ensurePassengerRowsForTrip();
          this.refreshTrip();
        }
      }).catch(e => {

      })
    });
  }

  /** True only for PROVIDER_ADMIN — map tiles + Directions load only after "Show route". */
  get deferMapRouteForProviderAdmin(): boolean {
    return this.isProviderAdmin;
  }

  get showTripMapCanvas(): boolean {
    return !this.deferMapRouteForProviderAdmin || this.providerMapRouteOptIn;
  }

  private shouldRequestDirectionsOnMap(): boolean {
    return !this.deferMapRouteForProviderAdmin || this.providerMapRouteOptIn;
  }

  onProviderShowRouteClick() {
    this.providerMapRouteOptIn = true;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.initializeMap();
      if (this.trip) {
        this.viewRoundTrip(this.trip);
      }
    }, 0);
  }


  getJobTypeText() {
    return this.main.getJobTypeText();
  }

  isBearer() {
    var payload = this.auth.getAdminPayload();
    if (payload.type == 'BEARER') {
      return true;
    }
    return false;
  }

  hasCustomerDiscount(): boolean {
    return !!(this.trip && CustomerDiscountUtils.hasDiscount(this.trip.customerDiscount));
  }

  getCustomerDiscountTypeLabel(): string {
    const d = this.trip && this.trip.customerDiscount;
    if (!d || !d.discount_type) {
      return '';
    }
    if (d.discount_type === 'percentage') {
      return 'Percentage';
    }
    if (d.discount_type === 'flat') {
      return 'Flat';
    }
    return String(d.discount_type);
  }

  getCustomerDiscountValueLabel(): string {
    return CustomerDiscountUtils.formatLabel(this.trip && this.trip.customerDiscount) || '';
  }

  /** Monetary amount saved on this trip (from snapshot, or derived from original − discounted). */
  getCustomerDiscountSavedAmount(): number | null {
    const d = this.trip && this.trip.customerDiscount;
    if (!d) {
      return null;
    }
    if (d.discount_amount != null && !isNaN(Number(d.discount_amount))) {
      return Number(d.discount_amount);
    }
    if (d.original_amount != null && d.discounted_amount != null) {
      const saved = Number(d.original_amount) - Number(d.discounted_amount);
      return isNaN(saved) ? null : saved;
    }
    return null;
  }

  onCumulativeChange() {
    if (!this.shouldAutoCalculateDeliveryFee()) {
      return;
    }
    var d = new QuickDialog(this.dialog).LoadingDialog("Updating Delivery Fee...");
    this.main.recalculateDeliveryFee(this.trip.id, this.trip.providerid, this.trip.cumulative).then(() => {
      d.close();
      // window.location.reload();
    }).catch(e => {
      d.close();
    });
  }

  private getPassengerDialogMeta() {
    return {
      deliveryFeeEnabled: !!(this.settings && this.settings.deliveryFee && this.settings.deliveryFee.enabled),
      disableDeliveryFeeCalculation: !!(this.trip && this.trip.overrideDelivery)
    };
  }

  private shouldAutoCalculateDeliveryFee(): boolean {
    return !!(this.settings && this.settings.deliveryFee && this.settings.deliveryFee.enabled
      && this.trip && !this.trip.overrideDelivery && this.trip.areas.length > 0);
  }

  private async handleManualDeliveryFeeOverride(): Promise<void> {
    await new QuickDialog(this.dialog).InfoDialog(
      'You manually changed the delivery fee. Automatic delivery fee calculation has been disabled for this trip.',
      'Delivery Fee Calculation Disabled',
      'OK'
    );
  }

  openPassengerDialog() {
    new QuickDialog(this.dialog).AddPassengerDialog(this.trip.id, this.getPassengerDialogMeta()).then(async (added: any) => {
      if (added) {
        await this.trip.reload(this.main);
        if (this.shouldAutoCalculateDeliveryFee()) {
          var d = new QuickDialog(this.dialog).LoadingDialog('Updating Delivery Fee...');
          this.main.recalculateDeliveryFee(this.trip.id, this.trip.providerid, this.trip.cumulative).then(() => {
            d.close();
            // window.location.reload();
          }).catch(e => {
            d.close();
            // window.location.reload();
          });
        } else {
          // window.location.reload();
        }
      }
    });
  }

  /** Same directory search as Add Passenger dialog (provider portal accounts). */
  get isPassengerDirectorySearchEnabled(): boolean {
    const p = this.auth.getAdminPayload();
    return !!(p && p.type === 'PROVIDER');
  }

  get isProviderAdmin(): boolean {
    const p = this.auth.getAdminPayload();
    return !!(p && p.type === 'PROVIDER');
  }

  /** Inline add-passenger (CC-style): never for bearers; provider admins with modify rights only. */
  get showProviderInlineAddPassenger(): boolean {
    return this.canModifyTrip() && this.isProviderAdmin && !this.isBearer();
  }

  /**
   * Company context for users/search — trip company when set, else same fallbacks as CC Trip Creator.
   */
  getPassengerSearchCompanyId(): number | null {
    if (this.trip && this.trip.companyid != null && this.trip.companyid !== undefined) {
      const n = typeof this.trip.companyid === 'number' ? this.trip.companyid : parseInt(String(this.trip.companyid), 10);
      if (!isNaN(n) && n > 0) {
        return n;
      }
    }
    const payload = this.auth.getAdminPayload();
    if (payload && payload.company_access && payload.company_access.length === 1) {
      const only = payload.company_access[0].companyid;
      const n = typeof only === 'number' ? only : parseInt(String(only), 10);
      if (!isNaN(n) && n > 0) {
        return n;
      }
    }
    const fallback = this.auth.getClientCompanyId();
    if (fallback != null && fallback > 0) {
      return fallback;
    }
    return null;
  }

  private discardPassengerSearchTimers() {
    Object.keys(this.passengerSearchTimers).forEach(uid => {
      clearTimeout(this.passengerSearchTimers[uid]);
      delete this.passengerSearchTimers[uid];
    });
  }

  /**
   * Legacy dialog link: bearers always; other roles that can modify trips but are not provider admins (e.g. super, dispatcher).
   */
  showLegacyAddPassengerControl(): boolean {
    if (!this.trip) {
      return false;
    }
    if (this.isBearer()) {
      return true;
    }
    return this.canModifyTrip() && !this.isProviderAdmin;
  }

  ensurePassengerRowsForTrip() {
    if (!this.showProviderInlineAddPassenger || !this.trip) {
      return;
    }
    const key = String(this.trip.id);
    if (this.tripPassengerRowsTripKey !== key) {
      this.tripPassengerRowsTripKey = key;
      this.discardPassengerSearchTimers();
      this.passengerRows = [this.newPassengerRow()];
    }
  }

  private newPassengerRow(): TripDetailsPassengerRow {
    return {
      uid: `td-p-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
      name: '',
      phone: '',
      email: '',
      addressText: '',
      locationInfo: null,
      userid: null,
      employeeid: null,
      detailsExpanded: false,
      showAutocomplete: false,
      filteredUsers: [],
      isSearching: false,
      selectedUser: null,
      lastPersistFingerprint: null,
      persistInFlight: false
    };
  }

  addPassengerRow(afterIndex?: number) {
    const row = this.newPassengerRow();
    if (afterIndex == null || afterIndex >= this.passengerRows.length - 1) {
      this.passengerRows.push(row);
    } else {
      this.passengerRows.splice(afterIndex + 1, 0, row);
    }
  }

  removePassengerRow(index: number) {
    if (this.passengerRows.length <= 1) {
      const old = this.passengerRows[0];
      if (old && this.passengerSearchTimers[old.uid]) {
        clearTimeout(this.passengerSearchTimers[old.uid]);
        delete this.passengerSearchTimers[old.uid];
      }
      this.passengerRows[0] = this.newPassengerRow();
      return;
    }
    const row = this.passengerRows[index];
    if (row && this.passengerSearchTimers[row.uid]) {
      clearTimeout(this.passengerSearchTimers[row.uid]);
      delete this.passengerSearchTimers[row.uid];
    }
    this.passengerRows.splice(index, 1);
  }

  trackPassengerByUid(_i: number, row: TripDetailsPassengerRow) {
    return row.uid;
  }

  isPassengerFromDirectorySearch(row: TripDetailsPassengerRow): boolean {
    return row.selectedUser != null || row.userid != null;
  }

  inviteOptionHighlighted(row: TripDetailsPassengerRow): boolean {
    if (this.isPassengerFromDirectorySearch(row)) {
      return false;
    }
    const e = (row.email || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
  }

  onPassengerNameInput(row: TripDetailsPassengerRow, event: any) {
    const searchTerm = event && event.target ? String(event.target.value) : '';
    row.name = searchTerm;
    if (row.selectedUser && searchTerm.trim() !== `${row.selectedUser.firstname} ${row.selectedUser.lastname}`.trim()) {
      row.selectedUser = null;
      row.userid = null;
      row.employeeid = null;
    }
    if (!this.isPassengerDirectorySearchEnabled) {
      row.filteredUsers = [];
      row.showAutocomplete = false;
      row.isSearching = false;
      return;
    }
    if (this.passengerSearchTimers[row.uid]) {
      clearTimeout(this.passengerSearchTimers[row.uid]);
      delete this.passengerSearchTimers[row.uid];
    }

    const trimmed = searchTerm.trim();
    const companyid = this.getPassengerSearchCompanyId();
    if (trimmed.length < 2 || !companyid) {
      row.filteredUsers = [];
      row.showAutocomplete = false;
      row.isSearching = false;
      this.zone.run(() => this.cdr.detectChanges());
      return;
    }

    row.showAutocomplete = true;
    row.isSearching = true;
    this.zone.run(() => this.cdr.detectChanges());

    this.passengerSearchTimers[row.uid] = setTimeout(() => {
      const term = (row.name || '').trim();
      if (term.length < 2 || !this.getPassengerSearchCompanyId()) {
        this.zone.run(() => {
          row.isSearching = false;
          row.showAutocomplete = false;
          row.filteredUsers = [];
          this.cdr.detectChanges();
        });
        return;
      }
      this.searchPassengerUsers(row, term);
    }, 280);
  }

  onPassengerNameFocus(row: TripDetailsPassengerRow) {
    if (!this.isPassengerDirectorySearchEnabled) {
      return;
    }
    const n = (row.name || '').trim();
    if (n.length < 2 || !this.getPassengerSearchCompanyId()) {
      return;
    }
    if (row.filteredUsers.length > 0) {
      row.showAutocomplete = true;
      this.zone.run(() => this.cdr.detectChanges());
    } else {
      this.searchPassengerUsers(row, n);
    }
  }

  onPassengerNameBlur(row: TripDetailsPassengerRow) {
    setTimeout(() => {
      this.zone.run(() => {
        row.showAutocomplete = false;
        this.cdr.detectChanges();
      });
    }, 250);
    this.tryPersistPassengerForReuse(row);
  }

  searchPassengerUsers(row: TripDetailsPassengerRow, searchTerm: string) {
    const companyid = this.getPassengerSearchCompanyId();
    const q = (searchTerm || '').trim();
    if (q.length < 2 || !companyid) {
      this.zone.run(() => {
        row.filteredUsers = [];
        row.showAutocomplete = false;
        row.isSearching = false;
        this.cdr.detectChanges();
      });
      return;
    }

    row.isSearching = true;
    row.showAutocomplete = true;
    this.zone.run(() => this.cdr.detectChanges());

    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}users/search?search=${encodeURIComponent(q)}&companyid=${companyid}`;

    this.http.get(url, { headers }).toPromise()
      .then(response => {
        const result = response.json();
        let users: any[] = [];
        if (Array.isArray(result && result.data)) {
          users = result.data;
        }
        this.zone.run(() => {
          row.filteredUsers = users;
          row.isSearching = false;
          row.showAutocomplete = users.length > 0 || q.length >= 2;
          this.cdr.detectChanges();
        });
      })
      .catch(() => {
        this.zone.run(() => {
          row.filteredUsers = [];
          row.isSearching = false;
          row.showAutocomplete = false;
          this.cdr.detectChanges();
        });
      });
  }

  selectPassengerUser(row: TripDetailsPassengerRow, user: any) {
    row.selectedUser = user;
    row.name = `${user.firstname} ${user.lastname}`.trim();
    row.phone = user.phone || '';
    row.email = user.email || '';
    row.userid = user.userid != null ? user.userid : null;
    row.employeeid = user.employeeid != null ? String(user.employeeid) : null;
    if (user.address && user.lat != null && user.lng != null) {
      row.addressText = user.address;
      row.locationInfo = null;
      LocationValidator.validateDropoffCoordinates(Number(user.lat), Number(user.lng), this.directions)
        .then(() => {
          this.zone.run(() => {
            const disp = (user.address || '').trim();
            row.locationInfo = {
              address: disp,
              lat: Number(user.lat),
              lng: Number(user.lng)
            };
            row.addressText = disp;
            this.cdr.detectChanges();
          });
        })
        .catch(() => {
          this.zone.run(() => {
            row.locationInfo = null;
            new QuickDialog(this.dialog).InfoDialog(
              'Location Not Allowed, Please select a location within Jamaica',
              'Invalid Location',
              'OK'
            );
            this.cdr.detectChanges();
          });
        });
    }
    row.showAutocomplete = false;
    row.filteredUsers = [];
    this.zone.run(() => this.cdr.detectChanges());
  }

  openPassengerLocationPicker(row: TripDetailsPassengerRow) {
    const loc = row.locationInfo;
    const lat = loc && loc.lat != null ? Number(loc.lat) : null;
    const lng = loc && loc.lng != null ? Number(loc.lng) : null;
    const options: LocationOptions = {
      defaultLocations:
        lat != null && lng != null && !isNaN(lat) && !isNaN(lng)
          ? [new LocationData((loc.address || row.addressText || '').trim(), lat, lng)]
          : []
    };
    new QuickDialog(this.dialog).LocationPickerDialog(options).then((locationDatas: LocationData[]) => {
      if (locationDatas && locationDatas[0]) {
        const ld = locationDatas[0];
        this.zone.run(() => {
          row.addressText = ld.address;
          row.locationInfo = { address: ld.address, lat: ld.lat, lng: ld.lng };
          this.cdr.detectChanges();
        });
      }
    }).catch(() => {});
  }

  private looksLikeOpenLocationCodeLine(s: string): boolean {
    if (!s || !String(s).trim()) {
      return false;
    }
    return /\b[23456789CFGHJMPQRVWX]{4,8}\+[23456789CFGHJMPQRVWX]{2,5}\b/i.test(s);
  }

  private mergeValidatedPassengerAddress(placeline: string, directionsLine: string): string {
    const a = (placeline || '').trim();
    const b = (directionsLine || '').trim();
    if (!a) {
      return b;
    }
    if (!b) {
      return a;
    }
    const bIsPlus = this.looksLikeOpenLocationCodeLine(b);
    const aIsPlus = this.looksLikeOpenLocationCodeLine(a);
    if (bIsPlus && !aIsPlus) {
      return a;
    }
    const aWords = a.split(/\s+/).filter(Boolean).length;
    if (a.indexOf(',') >= 0 || a.length > b.length || aWords >= 4) {
      return a;
    }
    if (bIsPlus) {
      return a;
    }
    return b;
  }

  private geocodeAddressToLatLng(address: string): Promise<{ lat: number; lng: number }> {
    return new Promise((resolve, reject) => {
      if (typeof google === 'undefined' || !google.maps || !google.maps.Geocoder) {
        reject('NO_GEOCODER');
        return;
      }
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { address: address.trim(), componentRestrictions: { country: 'jm' } },
        (results: any[], status: string) => {
          if (status === 'OK' && results && results[0] && results[0].geometry && results[0].geometry.location) {
            const p = results[0].geometry.location;
            resolve({ lat: p.lat(), lng: p.lng() });
          } else {
            reject(status);
          }
        }
      );
    });
  }

  private async resolvePassengerRowLocationIfNeeded(row: TripDetailsPassengerRow): Promise<boolean> {
    const name = (row.name || '').trim();
    if (!name) {
      return false;
    }
    const addrText = (row.addressText || '').trim();
    const hasCoords =
      row.locationInfo != null && row.locationInfo.lat != null && row.locationInfo.lng != null;
    if (!addrText || hasCoords) {
      return true;
    }
    try {
      const ll = await this.geocodeAddressToLatLng(addrText);
      const v = await LocationValidator.validateDropoffCoordinates(ll.lat, ll.lng, this.directions);
      row.locationInfo = {
        address: this.mergeValidatedPassengerAddress(addrText, v.address),
        lat: v.lat,
        lng: v.lng
      };
      row.addressText = row.locationInfo.address;
      return true;
    } catch (_e) {
      new QuickDialog(this.dialog).InfoDialog(
        'Could not verify this passenger address in Jamaica. Choose an address from the map picker or enter a full address.',
        'Address',
        'OK'
      );
      return false;
    }
  }

  togglePassengerDetails(row: TripDetailsPassengerRow) {
    row.detailsExpanded = !row.detailsExpanded;
  }

  splitPassengerName(full: string): { firstname: string; lastname: string } {
    const t = (full || '').trim();
    if (!t) {
      return { firstname: 'Passenger', lastname: '-' };
    }
    const parts = t.split(/\s+/);
    if (parts.length === 1) {
      return { firstname: parts[0], lastname: '-' };
    }
    return { firstname: parts[0], lastname: parts.slice(1).join(' ') };
  }

  tryPersistPassengerForReuse(row: TripDetailsPassengerRow) {
    if (!this.isProviderAdmin || this.isBearer() || row.userid || row.persistInFlight) {
      return;
    }
    const companyid = this.getPassengerSearchCompanyId();
    const companyName = this.trip && this.trip.companyName ? String(this.trip.companyName) : '';
    const name = (row.name || '').trim();
    const email = (row.email || '').trim();
    const phone = (row.phone || '').trim();
    if (!companyid || !name || !companyName) {
      return;
    }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return;
    }
    const fp = `${name}|${email}|${phone}`;
    if (row.lastPersistFingerprint === fp) {
      return;
    }
    row.persistInFlight = true;
    const { firstname, lastname } = this.splitPassengerName(name);
    const payload: any = {
      firstname,
      lastname,
      email,
      company: companyName,
      companyid,
      employeeid: `TD-${Date.now()}`,
      finalAddress: row.locationInfo ? row.locationInfo.address : (row.addressText || null),
      lat: row.locationInfo ? row.locationInfo.lat : null,
      lng: row.locationInfo ? row.locationInfo.lng : null
    };
    if (phone) {
      payload.phone = phone;
    }
    this.main.createUser(payload).then((res: any) => {
      row.persistInFlight = false;
      if (res && res.status !== false) {
        row.lastPersistFingerprint = fp;
      }
    }).catch(() => {
      row.persistInFlight = false;
    });
  }

  onPassengerEmailOrPhoneBlur(row: TripDetailsPassengerRow) {
    this.tryPersistPassengerForReuse(row);
  }

  invitePassenger(row: TripDetailsPassengerRow) {
    if (!this.isProviderAdmin || this.isBearer()) {
      return;
    }
    if (this.isPassengerFromDirectorySearch(row)) {
      return;
    }
    const email = (row.email || '').trim();
    const name = (row.name || '').trim();
    if (!this.inviteOptionHighlighted(row) || !name) {
      new QuickDialog(this.dialog).InfoDialog('Enter a valid email address to send an invitation.', 'Invite', 'OK');
      return;
    }
    const companyid = this.getPassengerSearchCompanyId();
    if (!companyid) {
      new QuickDialog(this.dialog).InfoDialog('This trip has no company; passenger invite is unavailable.', 'Invite', 'OK');
      return;
    }
    const companyName = this.trip && this.trip.companyName ? String(this.trip.companyName) : '';
    if (!companyName) {
      new QuickDialog(this.dialog).InfoDialog('Company name is missing for this trip.', 'Invite', 'OK');
      return;
    }
    row.persistInFlight = true;
    const { firstname, lastname } = this.splitPassengerName(name);
    const payload: any = {
      firstname,
      lastname,
      email,
      company: companyName,
      companyid,
      employeeid: row.employeeid || `INV-${Date.now()}`,
      finalAddress: row.locationInfo ? row.locationInfo.address : (row.addressText || null),
      lat: row.locationInfo ? row.locationInfo.lat : null,
      lng: row.locationInfo ? row.locationInfo.lng : null
    };
    if ((row.phone || '').trim()) {
      payload.phone = (row.phone || '').trim();
    }
    this.main.createUser(payload).then((res: any) => {
      row.persistInFlight = false;
      if (res && res.status !== false) {
        row.lastPersistFingerprint = `${name}|${email}|${(row.phone || '').trim()}`;
        new QuickDialog(this.dialog).InfoDialog(
          `A registration email was sent to ${email}.`,
          'Invitation sent',
          'OK'
        );
      } else {
        new QuickDialog(this.dialog).InfoDialog((res && res.message) || 'Could not send invitation.', 'Invite', 'OK');
      }
    }).catch(() => {
      row.persistInFlight = false;
      new QuickDialog(this.dialog).InfoDialog('Could not send invitation.', 'Invite', 'OK');
    });
  }

  async addPassengerStopToTrip(row: TripDetailsPassengerRow) {
    if (!this.trip || !this.showProviderInlineAddPassenger) {
      return;
    }
    const name = (row.name || '').trim();
    if (!name) {
      new QuickDialog(this.dialog).InfoDialog('Enter a passenger name.', 'Add Passenger', 'OK');
      return;
    }
    const resolved = await this.resolvePassengerRowLocationIfNeeded(row);
    if (!resolved) {
      return;
    }
    const d = new QuickDialog(this.dialog).LoadingDialog('Adding passenger...');
    const body: any = {
      label: name,
      name: name,
      phone: (row.phone || '').trim() || null,
      comments: '',
      fee: null,
      collection: null,
      location: row.locationInfo,
      locationdata: row.locationInfo,
      userid: row.userid,
      employeeid: row.employeeid
    };
    const em = (row.email || '').trim();
    if (em) {
      body.email = em;
    }
    try {
      await this.main.addPlaceholder(this.trip.id, body);
      d.close();
      this.finishPassengerRowAfterSuccessfulAdd(row);
      await this.afterPassengerAddedToTrip();
    } catch (_e) {
      d.close();
      new QuickDialog(this.dialog).InfoDialog('Unable to add this passenger. Please try again.', 'Add Passenger', 'OK');
    }
  }

  private finishPassengerRowAfterSuccessfulAdd(row: TripDetailsPassengerRow) {
    const idx = this.passengerRows.indexOf(row);
    if (idx < 0) {
      return;
    }
    if (this.passengerRows.length > 1) {
      this.removePassengerRow(idx);
    } else {
      this.passengerRows[0] = this.newPassengerRow();
    }
  }

  private async afterPassengerAddedToTrip() {
    await this.trip.reload(this.main);
    if (this.shouldAutoCalculateDeliveryFee()) {
      const d = new QuickDialog(this.dialog).LoadingDialog('Updating Delivery Fee...');
      try {
        await this.main.recalculateDeliveryFee(this.trip.id, this.trip.providerid, this.trip.cumulative);
      } finally {
        d.close();
      }
    }
    // window.location.reload();
  }


  edit(passenger: Area) {
    var index = this.trip.areas.indexOf(passenger);
    const originalFee = passenger.fee;
    const originalLocation = {
      address: passenger.address,
      lat: passenger.destinations[0].lat,
      lng: passenger.destinations[0].lng
    };
    const autoCalcActive = !!(this.settings && this.settings.deliveryFee && this.settings.deliveryFee.enabled && !this.trip.overrideDelivery);
    new QuickDialog(this.dialog).EditPassengerDialog(this.tripId, {
      name: passenger.destinations[0].person,
      fee: passenger.fee,
      collection: passenger.collection,
      comments: passenger.comments,
      phone: passenger.phone,
      locationdata: {

        address: passenger.address,
        lat: passenger.destinations[0].lat,
        lng: passenger.destinations[0].lng
      }
    }, this.getPassengerDialogMeta()).then(async (data: any) => {
      if (data) {
        const feeChanged = Number(data.fee) !== Number(originalFee);
        const locationChanged = stopLocationChanged(originalLocation, data.locationdata);
        passenger.destinations[0].person = data.name;
        passenger.phone = data.phone;
        passenger.comments = data.comments;
        passenger.fee = data.fee;
        passenger.collection = data.collection;
        passenger.address = data.locationdata.address;
        passenger.destinations[0].lat = data.locationdata.lat;
        passenger.destinations[0].lng = data.locationdata.lng;

        this.main.editArea(this.trip.id, index, passenger).then(async () => {
          if (feeChanged && autoCalcActive) {
            this.trip.overrideDelivery = true;
            try {
              await this.main.updateTrip(this.trip);
              await this.handleManualDeliveryFeeOverride();
            } catch (e) {
              this.trip.overrideDelivery = false;
              new QuickDialog(this.dialog).InfoDialog("Unable to update the override delivery setting, please try again later", "Update Failed", "OK");
            }
            return;
          }
          if (this.shouldAutoCalculateDeliveryFee() && locationChanged) {
            var d = new QuickDialog(this.dialog).LoadingDialog("Updating Delivery Fee...");
            this.main.recalculateDeliveryFee(this.trip.id, this.trip.providerid, this.trip.cumulative).then(() => {
              d.close();
              // window.location.reload();
            }).catch(e => {
              d.close();
            });
          } else {
            // window.location.reload();
          }
        }).catch(e => {
          new QuickDialog(this.dialog).InfoDialog("Unable to update the information, please try again later", "Update Failed", "OK");
        })
      }
    });
  }

  getTotaCollection() {
    var total = 0;
    if (!this.trip) {
      return total;
    }
    this.trip.areas.forEach(a => {
      total += a.collection;
    })
    return total;
  }

  getDisplayedTripCost() {
    if (!this.trip) {
      return 0;
    }
    const rawTotal = this.getRawTripCostTotal();
    if (this.hasCustomerDiscount()) {
      const d = this.trip.customerDiscount;
      if (d.discounted_amount != null && !isNaN(Number(d.discounted_amount))) {
        return Number(d.discounted_amount);
      }
      const preview = CustomerDiscountUtils.preview(rawTotal, d);
      if (preview) {
        return preview.discounted;
      }
    }
    return rawTotal;
  }

  /** Sum of stop fees (or trip earnings when there are no areas). Pre-discount when areas store list prices. */
  private getRawTripCostTotal(): number {
    if (!this.trip.areas || this.trip.areas.length === 0) {
      return this.trip.earnings != null && !isNaN(Number(this.trip.earnings)) ? Number(this.trip.earnings) : 0;
    }
    return this.trip.areas.reduce((total, area: any) => {
      const fee = Number(area && area.fee);
      return total + (isNaN(fee) ? 0 : fee);
    }, 0);
  }

  updateMetaData() {
    this.main.updateMetaData(this.trip.id, this.trip.metadata);
  }

  updateReportDate() {
    if (!this.trip.reportDate) {
      new QuickDialog(this.dialog).InfoDialog("Please select a valid date", "Invalid Date", "OK");
      return;
    }
    
    this.main.updateReportDate(this.trip.id, this.trip.reportDate.toISOString()).then(() => {
      new QuickDialog(this.dialog).InfoDialog("Trip date updated successfully", "Success", "OK");
      this.refreshTrip();
    }).catch(e => {
      new QuickDialog(this.dialog).InfoDialog("Unable to update trip date, please try again later", "Update Failed", "OK");
    });
  }

  startEditReportDate() {
    this.editingReportDate = true;
    // Initialize the daterangepicker after the view is updated
    setTimeout(() => {
      var startDate = this.trip.reportDate ? moment(this.trip.reportDate) : moment();
      $('#reportDatePicker').daterangepicker({
        singleDatePicker: true,
        startDate: startDate,
        timePicker: true,
        locale: {
          format: 'DD, MMM YYYY hh:mm A'
        },
      }, (sD: moment.Moment, eD: moment.Moment, label) => {
        this.editingReportDateValue = sD.format('YYYY-MM-DD hh:mm A');
      });
    }, 100);
  }

  saveReportDate() {
    if (!this.editingReportDateValue) {
      new QuickDialog(this.dialog).InfoDialog("Please select a valid date", "Invalid Date", "OK");
      return;
    }
    
    this.trip.reportDate = moment(this.editingReportDateValue, 'YYYY-MM-DD hh:mm A').toDate();
    this.updateReportDate();
    this.editingReportDate = false;
    this.editingReportDateValue = '';
  }

  cancelEditReportDate() {
    this.editingReportDate = false;
    this.editingReportDateValue = '';
    // Destroy the daterangepicker instance
    if ($('#reportDatePicker').data('daterangepicker')) {
      $('#reportDatePicker').data('daterangepicker').remove();
    }
  }


  delete() {
    new QuickDialog(this.dialog).DecisionDialog({
      message: `Are you sure you want to delete this trip? It will be moved to the recycle bin.`,
      options: [
        {
          code: 'yes',
          message: "Yes, DELETE THE TRIP",
          icon: 'fa-thumbs-up'
        },
        {
          code: 'no',
          message: 'No, cancel',
          icon: 'fa-ban'
        }
      ]
    }).then(async (choice) => {
      if (choice == 'yes') {
        this.main.deleteTrip(this.trip.id).then(() => {
          this.router.navigate(['/admin-portal/dashboard']);
        }).catch(e => {
          new QuickDialog(this.dialog).InfoDialog("Unable to delete the trip", "", "OK");
        })
      }
    });
  }

  cancel() {
    new QuickDialog(this.dialog).DecisionDialog({
      message: `Are you sure you want to cancel this trip?`,
      options: [
        {
          code: 'yes',
          message: "Yes, Cancel Trip",
          icon: 'fa-thumbs-up'
        },
        {
          code: 'no',
          message: 'No, Do not cancel',
          icon: 'fa-ban'
        }
      ]
    }).then(async (choice) => {
      if (choice == 'yes') {
        this.main.cancelTrip(this.trip.id).then(() => {
        }).catch(e => {
          new QuickDialog(this.dialog).InfoDialog("Unable to cancel the trip", "", "OK");
        })
      }
    });
  }

  removePassenger(passenger: Area) {

    new QuickDialog(this.dialog).DecisionDialog({
      message: `Are you sure you want to remove this stop?`,
      options: [
        {
          code: 'yes',
          message: "Yes",
          icon: 'fa-thumbs-up'
        },
        {
          code: 'no',
          message: 'No, cancel',
          icon: 'fa-ban'
        }
      ]
    }).then(async (choice) => {
      if (choice == 'yes') {
        this.main.removePassenger(this.trip.id, passenger.userid).then(() => {
          if (this.shouldAutoCalculateDeliveryFee()) {
            var d = new QuickDialog(this.dialog).LoadingDialog("Updating Delivery Fee...");
            this.main.recalculateDeliveryFee(this.trip.id, this.trip.providerid, this.trip.cumulative).then(() => {
              d.close();
              // window.location.reload();
            }).catch(e => {
              d.close();
            });
          }
        }).catch(e => {
          new QuickDialog(this.dialog).InfoDialog("Unable to remove passenger", "", "OK");
        })
      }
    });
  }

  start() {
    new QuickDialog(this.dialog).DecisionDialog({
      message: `Are you sure you want to start this trip`,
      options: [
        {
          code: 'yes',
          message: "Yes",
          icon: 'fa-thumbs-up'
        },
        {
          code: 'no',
          message: 'No, cancel',
          icon: 'fa-ban'
        }
      ]
    }).then(async (choice) => {
      if (choice == 'yes') {
        this.main.startTrip(this.trip.id).then(() => {

        }).catch(e => {
          new QuickDialog(this.dialog).InfoDialog("Unable to start the trip", "", "OK");
        })
      }
    });
  }

  complete() {
    new QuickDialog(this.dialog).DecisionDialog({
      message: `Are you sure you want to mark this trip as completed`,
      options: [
        {
          code: 'yes',
          message: "Yes",
          icon: 'fa-thumbs-up'
        },
        {
          code: 'no',
          message: 'No, cancel',
          icon: 'fa-ban'
        }
      ]
    }).then(async (choice) => {
      if (choice == 'yes') {
        this.main.completeTrip(this.trip.id).then(() => {

        }).catch(e => {
          new QuickDialog(this.dialog).InfoDialog("Unable to mark the trip as completed", "", "OK");
        })
      }
    });
  }

  getDropOffTime(passenger: Area) {
    var found = this.trip.droppedOff.find(x => x.employeeid == passenger.employeeid);
    if (!found) {
      return null;
    } else {
      return this.formatDate(found.time)
    }
  }

  canModifyTrip() {
    return this.auth.hasOneOfRoles([
      CONSTANTS.ADMIN_TYPE_PROVIDER,
      CONSTANTS.ADMIN_TYPE_SUPER,
      CONSTANTS.ROLE_TYPE_DISPATCHER
    ])
  }


  canUnassign() {
    return this.auth.hasOneOfRoles([
      CONSTANTS.ADMIN_TYPE_PROVIDER,
      CONSTANTS.ADMIN_TYPE_SUPER,
      CONSTANTS.ROLE_TYPE_DISPATCHER
    ])
  }

  canPublish() {
    return this.auth.hasOneOfRoles([
      CONSTANTS.ADMIN_TYPE_PROVIDER,
      CONSTANTS.ADMIN_TYPE_SUPER,
      CONSTANTS.ROLE_TYPE_DISPATCHER
    ])
  }

  /** Platform `driverid`, or portal assignment when API leaves `driverid` null. */
  get hasTripDriverAssigned(): boolean {
    const v = this.trip && this.trip.vehicleReservation && this.trip.vehicleReservation.vehicle;
    if (!v) {
      return false;
    }
    const rawId = v.driverid;
    if (rawId != null) {
      const n = Number(rawId);
      if (!isNaN(n) && n > 0) {
        return true;
      }
    }
    if (String(v.driver_kind || '').toLowerCase() !== 'portal') {
      return false;
    }
    const pid = v.portal_driver_id;
    if (pid == null) {
      return false;
    }
    const pn = Number(pid);
    return !isNaN(pn) && pn > 0;
  }

  /** Second line under driver name: year/make/model, or portal `vehicle_name`. */
  assignedVehicleSubtitle(vehicle: any): string {
    if (!vehicle) {
      return '';
    }
    const parts: string[] = [];
    if (vehicle.year != null && String(vehicle.year).trim() !== '') {
      parts.push(String(vehicle.year));
    }
    if (vehicle.make != null && String(vehicle.make).trim() !== '') {
      parts.push(String(vehicle.make).trim());
    }
    if (vehicle.model != null && String(vehicle.model).trim() !== '') {
      parts.push(String(vehicle.model).trim());
    }
    const joined = parts.join(' ').trim();
    if (joined) {
      return joined;
    }
    const name = vehicle.vehicle_name;
    if (name != null && String(name).trim() !== '') {
      return String(name).trim();
    }
    return '';
  }

  format(date: Date) {
    return moment(date).format(DateConstants.shortDateTimeFormat2);
  }
  unassign() {
    this.driverService.unassignTrip(this.trip.id).then(() => {
      this.refreshTrip();
    }).catch(e => {
      new QuickDialog(this.dialog).InfoDialog("Unable to unassign trip", "Error", "OK");
    });
  }


  assignToDriver(driver) {
    if (!driver || !this.trip) {
      return;
    }
    driver.tripid = this.trip.id;
    if (driver.isPortalDriver && driver.portalDriverId != null) {
      const portalId = Number(driver.portalDriverId);
      if (isNaN(portalId) || portalId <= 0) {
        new QuickDialog(this.dialog).InfoDialog("The trip was not assigned to the driver.", "Not Assigned", "OK");
        return;
      }
      const payload: any = {
        tripid: this.trip.id,
        vehicleid: 0,
        driverid: portalId,
        driver_kind: "portal",
        portal_driver_id: portalId
      };
      this.driverService.assignTrip(payload).then((res) => {
        this.refreshTrip();
        new QuickDialog(this.dialog).InfoDialog("The trip was assigned to the driver", "Assiged", "OK");
      }).catch(e => {
        new QuickDialog(this.dialog).InfoDialog("The trip was not assigned to the driver.", "Not Assigned", "OK");
      });
      return;
    }
    new QuickDialog(this.dialog).driverVehiclesDialog(driver).then(payload => {
      if (payload) {
        this.driverService.assignTrip(payload).then((res) => {
          this.refreshTrip();
          new QuickDialog(this.dialog).InfoDialog("The trip was assigned to the driver", "Assiged", "OK");
        }).catch(e => {
          new QuickDialog(this.dialog).InfoDialog("The trip was not assigned to the driver.", "Not Assigned", "OK");
        })
      }
    })
  }


  onDriverSearch(event) {
    if (!this.driverSearch.nativeElement.value) {
      this.filteredDrivers = this.drivers;
    } else {
      this.filteredDrivers = this.drivers.filter(x =>
        (`${x.firstname} ${x.lastname}`.toLocaleLowerCase()).includes(this.driverSearch.nativeElement.value.toLocaleLowerCase())
      );
    }
  }

  refreshTrip() {
    this.main.getTrip(this.tripId).then((result: any) => {
      if (result.data) {
        this.trip = Trip.createTripFromRawTripData(result.data);
        this.ensurePassengerRowsForTrip();
        if (this.shouldRequestDirectionsOnMap()) {
          this.viewRoundTrip(this.trip);
        }
      }
    }).catch(e => {
      console.log(e);
    })
  }

  registerSocketListeners() {
    this.socketService.connect().then(() => {
      if (this.socketService.registerDriverLocationListener()) {
        this.socketService.onDriverLocation.subscribe((data) => {
          const v = this.trip && this.trip.vehicleReservation && this.trip.vehicleReservation.vehicle;
          if (!v) {
            return;
          }
          const platformMatch = v.driverid != null && Number(v.driverid) > 0
            && Number(data.driverid) === Number(v.driverid);
          const portalMatch = String(v.driver_kind || '').toLowerCase() === 'portal'
            && v.portal_driver_id != null
            && Number(data.driverid) === Number(v.portal_driver_id);
          if (!platformMatch && !portalMatch) {
            return;
          }
          if (!this.shouldRequestDirectionsOnMap() || !this.mapControls.map) {
            this.driverLocation = data;
            return;
          }
          this.driverLocation = data;
          var location = new google.maps.LatLng(data.lat, data.lng);
          if (this.driverMarker) {
            this.driverMarker.setMap(null);
            var index = this.mapControls.markers.indexOf(this.driverMarker);
            if (index > -1) {
              this.mapControls.markers.splice(index, 1);
            }
          }
          this.driverMarker = this.mapControls.addMarker(location, "", false, "busmarker.png");
          if (this.lock) {
            this.mapControls.centerMapOnLoaction(location);
          }
        });
      }
      if (this.socketService.registerTripUpdateListener()) {
        this.socketService.onTripUpdate.subscribe((data) => {
          this.refreshTrip();
        });
      }
    }).catch(e => {
      console.log(e);
    })
  }

  onPublishChange(event: MatSlideToggleChange) {
    var payload = this.main.getAdminPayload();
    var notification = payload.type == 'BEARER' ? true : false;
    this.main.updateTripPublishStatus([this.trip.id], event.source.checked, notification).then(async () => {
      this.refreshTrip();
      if (notification && event.source.checked && !this.hasTripDriverAssigned) {
        new QuickDialog(this.dialog).InfoDialog("A broadcast notification was sent out to all drivers for them to accept and complete the job.", "Notification Sent", "OK");
      }
    }).catch(e => {
      new QuickDialog(this.dialog).InfoDialog("Unable to update trip", "Publish Failed", "OK");
    });
  }

  onOverrideDeliveryChange(event: MatSlideToggleChange) {
    this.main.updateTrip(this.trip).then(() => {
      this.trip.overrideDelivery = event.source.checked;
    }).catch(e => {
      this.trip.overrideDelivery = !event.source.checked;
      new QuickDialog(this.dialog).InfoDialog("Unable to update the override delivery setting, please try again later", "Update Failed", "OK");
    });
  }


  viewRoundTrip(trip: Trip, index = 0) {
    this.mapControls.setMultiTripState(false);
    trip.getDirectionsGoogle(this.directions, {
      avoidTolls: true,
      orderwaypoints: true,
      splitDirections: true
    }).then(res => {
      this.trip.legs = res.legs;
      this.trip.currentLegIndex = index;
      this.showTripOnMap(res);
    }).catch(e => {
      alert("Error getting directions:" + e);
    })
  }

  nextLeg() {
    this.trip.nextLeg();
    this.showTripOnMap(this.trip);
  }

  prevLeg() {
    this.trip.prevLeg();
    this.showTripOnMap(this.trip);
  }

  private showTripOnMap(trip: Trip) {

    this.mapControls.clearMarkers();
    this.mapControls.directionsDisplay.setDirections(trip.legs[trip.currentLegIndex]);
    this.directionsMarkers = this.mapControls.addDirectionsMarkers(trip, null);
  }

  openCostDialog() {
    new QuickDialog(this.dialog).changeCost(this.trip).then(added => {
      if (added) {
        this.refreshTrip();
      }
    })
  }

  openDestinationDialog() {
    new QuickDialog(this.dialog).selectDestination(this.trip).then(added => {
      if (added) {
        window.location.reload();
      }
    })
  }

  openShareDialog() {
    new QuickDialog(this.dialog).ShareLinkDialog(this.trip).then(added => {
      if (added) {
        new QuickDialog(this.dialog).InfoDialog("The tracking link was emailed to the customer.", "Sent", "OK")
      }
    })
  }


  initializeMap() {
    if (!this.mapReference || !this.mapReference.nativeElement) {
      return;
    }
    this.mapControls.initialize(this.mapReference);
    let jaLat = 18.9350138;
    let jaLng = -77.7981928;
    this.mapControls.createMapAndCenterOnLoaction(jaLat, jaLng);
    //this.mapControls.centerMapOnCurrentPosition();
  }

  getCompany(id: number) {
    this.companyService.getClientById(id).then((results: any) => {
      this.company = results.data;
      console.log(this.company);
    }).catch(e => {
      console.log(e);
    })
  }

  getCredentials(name: String) {
    if (!name) {
      return "";
    }
    var nameParts = name.split(" ");
    if (nameParts.length > 1) {
      return `${nameParts[0].charAt(0)}${nameParts[1].charAt(0)}`;
    } else {
      return `${nameParts[0].charAt(0)}`;
    }
  }


  getSourceLabel() {
    if (!this.trip) {
      return "...";
    }
    return Trip.getSourceLabel(this.trip);
  }

  getDestinationLabel() {
    if (!this.trip) {
      return "...";
    }
    return Trip.getDestinationLabel(this.trip);
  }

  getPickupType() {
    if (this.trip) {
      return Trip.getPickupType(this.trip);
    }
    return "...";
  }

  swapPoints() {
    var d = new QuickDialog(this.dialog).LoadingDialog("Please wait...");
    this.main.swapPointToPoint(this.trip.id).then(() => {
      d.close();
      this.refreshTrip();
    }).catch(e => {
      d.close();
    })
  }

  getPickupCode() {
    if (this.trip) {
      return Trip.getPickupTypeCode(this.trip);
    }
    return null;
  }


  hideCost() {
    return this.auth.hasOneOfRoles([
      CONSTANTS.ROLE_TYPE_DISPATCHER
    ]);
  }

  formatReportDate(date) {
    if (date) {
      return moment(date).format(DateConstants.shortDateTimeFormate);
    } else {
      return 'N/A';
    }
  }


  formatDate(date) {
    if (date) {
      return moment(date).format(DateConstants.shortDateTimeFormate);
    } else {
      return 'N/A';
    }
  }

  formatDistance(d: any) {
    if (d) {
      return `${(d / 1000).toFixed(2)} km`;
    } else {
      return "0 km";
    }
  }

  getProgress() {
    if (this.trip) {
      var dropped = this.trip.droppedOff.length;
      var total = this.trip.areas.length;
      return ((dropped / total) * 100);
    } else {
      return 10;
    }
  }

  getStatusClass(state) {
    if (state == CONSTANTS.TRIP_COMPLETED || state == CONSTANTS.TRIP_ENDED) {
      return "status-complete";
    } else if (state == CONSTANTS.TRIP_CREATED) {
      return "status-created";
    } else if (state == CONSTANTS.TRIP_STARTED) {
      return "status-started";
    } else if (state == CONSTANTS.TRIP_CANCELLED) {
      return "status-cancelled"
    } else {
      return 'status-created';
    }
  }

  onDragStart(event: DragEvent, index: number) {
    this.dragSourceIndex = index;
    event.dataTransfer.effectAllowed = 'move';
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }

  onDrop(event: DragEvent, dropIndex: number) {
    event.preventDefault();

    if (this.dragSourceIndex === dropIndex) {
      return;
    }

    // Store original areas array
    const originalAreas = [...this.trip.areas];

    // Get the dragged area
    const draggedArea = this.trip.areas[this.dragSourceIndex];

    // Remove from old position and insert at new position
    this.trip.areas.splice(this.dragSourceIndex, 1);
    this.trip.areas.splice(dropIndex, 0, draggedArea);

    // Show confirmation dialog
    new QuickDialog(this.dialog).DecisionDialog({
      message: 'Are you sure you want to reorder these stops?',
      options: [
        {
          code: 'yes',
          message: 'Yes',
          icon: 'fa-thumbs-up'
        },
        {
          code: 'no',
          message: 'Cancel',
          icon: 'fa-ban'
        }
      ]
    }).then(confirmed => {
      if (confirmed == 'yes') {
        // Keep the new order
        // Here you would call your API to save the new order
        // this.main.updateTripAreas(this.trip.id, this.trip.areas);
        this.trip.passengers = [];
        this.trip.areas.forEach((area) => {
          this.trip.passengers.push(area.destinations[0].person);
        });
        this.main.updateTrip(this.trip).then(() => {
          this.refreshTrip();
        }).catch(e => {
          new QuickDialog(this.dialog).InfoDialog("Unable to update the trip", "Update Failed", "OK");
        });
      } else {
        // Restore original order
        this.trip.areas = originalAreas;
      }
      // Reset drag source index
      this.dragSourceIndex = -1;
    });
  }

  viewPassengerDetails(passenger: Area) {
    new QuickDialog(this.dialog).EditPassengerDialog(this.tripId, {
      name: passenger.destinations[0].person,
      fee: passenger.fee,
      collection: passenger.collection,
      comments: passenger.comments,
      phone: passenger.phone,
      locationdata: {
        address: passenger.address,
        lat: passenger.destinations[0].lat,
        lng: passenger.destinations[0].lng
      }
    }, { readOnly: true });
  }

  viewPassengerImages(passenger: Area) {
    const dialogRef = this.dialog.open(PassengerImagesComponent, {
      width: '600px',
      data: { passenger: passenger }
    });
  }

  // Helper methods for customer review display
  getStars(rating: number): number[] {
    return Array(Math.floor(rating || 0)).fill(0);
  }

  getEmptyStars(rating: number): number[] {
    const filledStars = Math.floor(rating || 0);
    return Array(5 - filledStars).fill(0);
  }

  getTripRating() {
    if (!this.trip || !this.trip.rating) {
      return "...";
    }
    
    const ratingObj = this.trip.rating;
    const rating = ratingObj.rating || 0;
    const driver = ratingObj.driver || 0;
    const recommend = ratingObj.recommend || 0;
    
    const average = (rating + driver + recommend) / 3;
    return Math.round(average * 10) / 10; // Round to 1 decimal place
  }

  viewTripRating() {
    if (!this.trip || !this.trip.rating) {
      return;
    }

    // Use the DeliveryRatingDialog method with read-only mode
    new QuickDialog(this.dialog).DeliveryRatingDialog(this.trip, true).then(() => {
      // Dialog closed
    }).catch(e => {
      console.error('Error opening rating dialog:', e);
    });
  }

  resetChangeHistory() {
    this.changeHistoryExpanded = false;
    this.changeHistoryLoading = false;
    this.changeHistoryLoaded = false;
    this.changeHistoryError = null;
    this.changeHistoryData = null;
    this.changeHistoryEntries = [];
    this.expandedChangelogEntryIndexes = {};
  }

  toggleChangeHistory() {
    this.changeHistoryExpanded = !this.changeHistoryExpanded;
    if (this.changeHistoryExpanded && !this.changeHistoryLoaded && !this.changeHistoryLoading) {
      this.loadChangeHistory();
    }
  }

  loadChangeHistory() {
    if (!this.tripId || this.changeHistoryLoading) {
      return;
    }

    this.changeHistoryLoading = true;
    this.changeHistoryError = null;

    this.main.getTripChangelog(this.tripId).then((result: any) => {
      this.changeHistoryLoading = false;
      this.changeHistoryLoaded = true;

      if (!result || result.status === false) {
        this.changeHistoryError = (result && result.message) || 'Unable to load change history.';
        return;
      }

      const data = result.data as TripChangelogData;
      this.changeHistoryData = data;
      this.changeHistoryEntries = this.sortChangelogEntries(data.entries || []);
    }).catch((e) => {
      this.changeHistoryLoading = false;
      this.changeHistoryLoaded = true;

      if (e && e.status === 401) {
        this.router.navigate(['/admin-portal/login']);
        return;
      }

      if (e && e.status === 404) {
        this.changeHistoryError = 'Trip not found.';
        return;
      }

      this.changeHistoryError = 'Unable to load change history. Please try again.';
    });
  }

  private sortChangelogEntries(entries: TripChangelogEntry[]): TripChangelogEntry[] {
    return [...entries].sort((a, b) => {
      const aTime = a.time ? moment(a.time).valueOf() : 0;
      const bTime = b.time ? moment(b.time).valueOf() : 0;
      if (bTime !== aTime) {
        return bTime - aTime;
      }
      return (b.index || 0) - (a.index || 0);
    });
  }

  formatChangelogTime(time: string | null): string {
    if (!time) {
      return 'Unknown time';
    }
    return moment(time).format('MMM D, YYYY h:mm A');
  }

  getActorTypeLabel(actorType: TripChangelogActorType): string {
    switch (actorType) {
      case 'DISPATCHER':
        return 'Dispatcher';
      case 'DRIVER':
        return 'Driver';
      case 'ADMIN':
        return 'Admin';
      case 'SYSTEM':
        return 'System';
      default:
        return 'Unknown';
    }
  }

  getActorTypeBadgeClass(actorType: TripChangelogActorType): string {
    switch (actorType) {
      case 'DISPATCHER':
        return 'changelog-badge changelog-badge--dispatcher';
      case 'DRIVER':
        return 'changelog-badge changelog-badge--driver';
      case 'ADMIN':
        return 'changelog-badge changelog-badge--admin';
      case 'SYSTEM':
        return 'changelog-badge changelog-badge--system';
      default:
        return 'changelog-badge changelog-badge--unknown';
    }
  }

  toggleChangelogEntry(entry: TripChangelogEntry) {
    this.expandedChangelogEntryIndexes[entry.index] = !this.expandedChangelogEntryIndexes[entry.index];
  }

  isChangelogEntryExpanded(entry: TripChangelogEntry): boolean {
    return !!this.expandedChangelogEntryIndexes[entry.index];
  }

  hasChangelogEntryDetails(entry: TripChangelogEntry): boolean {
    return Array.isArray(entry.changes) && entry.changes.length > 0;
  }

  isImportantChangelogChange(change: TripChangelogChange): boolean {
    const field = (change.field || '').toLowerCase();
    return field.includes('collection') || field.includes('fee') || field.includes('droppedoff');
  }

  hasChangelogChangeDetail(change: TripChangelogChange): boolean {
    return !this.isChangelogValueEmpty(change.before) || !this.isChangelogValueEmpty(change.after);
  }

  isChangelogAddition(change: TripChangelogChange): boolean {
    return this.isChangelogValueEmpty(change.before) && !this.isChangelogValueEmpty(change.after);
  }

  isChangelogRemoval(change: TripChangelogChange): boolean {
    return !this.isChangelogValueEmpty(change.before) && this.isChangelogValueEmpty(change.after);
  }

  isChangelogValueEmpty(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    if (Array.isArray(value)) {
      return value.length === 0;
    }
    if (typeof value === 'object') {
      return Object.keys(value).length === 0;
    }
    return false;
  }

  getChangelogBeforeLines(change: TripChangelogChange): ChangelogDisplayLine[] {
    return this.formatChangelogDetailLines(change.before, change);
  }

  getChangelogAfterLines(change: TripChangelogChange): ChangelogDisplayLine[] {
    return this.formatChangelogDetailLines(change.after, change);
  }

  private formatChangelogDetailLines(value: any, change: TripChangelogChange): ChangelogDisplayLine[] {
    if (this.isChangelogValueEmpty(value)) {
      return [];
    }

    if (this.isChangelogStopObject(value)) {
      return this.formatChangelogStopLines(value);
    }

    if (this.isChangelogPassengerList(value)) {
      return value.map((passenger: any) => ({
        value: passenger.name || passenger.person || 'Unknown passenger'
      }));
    }

    if (this.isChangelogPassengerObject(value)) {
      return [{ value: value.name || value.person }];
    }

    if (Array.isArray(value)) {
      if (value.length === 0) {
        return [];
      }
      if (value.every(item => typeof item === 'string' || typeof item === 'number')) {
        return value.map(item => ({ value: String(item) }));
      }
      return value.map((item, index) => ({
        label: `Item ${index + 1}`,
        value: this.formatChangelogPrimitive(item, change)
      }));
    }

    const primitive = this.formatChangelogPrimitive(value, change);
    if (primitive) {
      return [{ value: primitive }];
    }

    return [];
  }

  private isChangelogStopObject(value: any): boolean {
    return value
      && typeof value === 'object'
      && !Array.isArray(value)
      && ('person' in value || 'address' in value || 'employeeid' in value);
  }

  private isChangelogPassengerList(value: any): boolean {
    return Array.isArray(value)
      && value.length > 0
      && value.every(item => item && typeof item === 'object' && (item.name || item.person));
  }

  private isChangelogPassengerObject(value: any): boolean {
    return value
      && typeof value === 'object'
      && !Array.isArray(value)
      && (value.name || value.person)
      && !this.isChangelogStopObject(value);
  }

  private formatChangelogStopLines(stop: any): ChangelogDisplayLine[] {
    const lines: ChangelogDisplayLine[] = [];
    const name = stop.person || stop.name;
    if (name) {
      lines.push({ label: 'Passenger', value: name });
    }
    if (stop.address) {
      lines.push({ label: 'Address', value: stop.address });
    }
    if (stop.phone) {
      lines.push({ label: 'Phone', value: stop.phone });
    }
    if (stop.fee) {
      lines.push({ label: 'Delivery fee', value: this.formattedNumber.format(stop.fee) });
    }
    if (stop.collection) {
      lines.push({ label: 'Cash to collect', value: this.formattedNumber.format(stop.collection) });
    }
    if (stop.droppedOff === true) {
      lines.push({ label: 'Status', value: 'Delivered' });
    } else if (stop.droppedOff === false) {
      lines.push({ label: 'Status', value: 'Not yet delivered' });
    }
    if (stop.comments) {
      lines.push({ label: 'Notes', value: stop.comments });
    }
    return lines;
  }

  private formatChangelogPrimitive(value: any, change: TripChangelogChange): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const field = (change.field || '').toLowerCase();
    if (typeof value === 'number') {
      if (field.includes('collection') || field.includes('fee') || field.includes('cost')) {
        return this.formattedNumber.format(value);
      }
      return String(value);
    }

    if (typeof value === 'boolean') {
      if (field.includes('droppedoff') || field.includes('dropped')) {
        return value ? 'Delivered' : 'Not yet delivered';
      }
      return value ? 'Yes' : 'No';
    }

    if (typeof value === 'object') {
      const name = value.name || value.person;
      if (name) {
        return name;
      }
      return '';
    }

    return String(value);
  }

  displayChangelogEmail(email: string | null): string {
    return email || '—';
  }
}

